import React, { useState, useMemo } from 'react';

const HelpIcon = ({ text }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setPosition({ x: rect.right + 10, y: rect.top - 10 });
    setShowPopup(true);
  };
  return (
    <div style={{ display: 'inline-block', position: 'relative' }}>
      <span onMouseEnter={handleMouseEnter} onMouseLeave={() => setShowPopup(false)} style={{ display: 'inline-block', marginLeft: '6px', width: '18px', height: '18px', backgroundColor: '#0066cc', color: 'white', borderRadius: '50%', textAlign: 'center', lineHeight: '18px', fontSize: '12px', fontWeight: 'bold', cursor: 'help' }}>?</span>
      {showPopup && <div onMouseEnter={() => setShowPopup(true)} onMouseLeave={() => setShowPopup(false)} style={{ position: 'fixed', top: `${position.y}px`, left: `${position.x}px`, background: '#1e293b', border: '2px solid #0066cc', borderRadius: '8px', padding: '12px 16px', maxWidth: '280px', color: '#e5e7eb', fontSize: '13px', lineHeight: '1.5', zIndex: 9999, boxShadow: '0 8px 24px rgba(0,0,0,0.6)', pointerEvents: 'auto' }}>{text}</div>}
    </div>
  );
};

const UpgradeModal = ({ upgrade, onClose, onAdd }) => {
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.6)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onClose}>
      <div style={{ background: '#1e293b', border: '2px solid #0066cc', borderRadius: '12px', padding: '24px', maxWidth: '500px', width: '90%', color: '#e5e7eb', boxShadow: '0 10px 40px rgba(0,0,0,0.8)', maxHeight: '80vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
        <h2 style={{ margin: '0 0 12px', fontSize: '22px', color: '#10b981' }}>{upgrade.name}</h2>
        <div style={{ fontSize: '13px', lineHeight: '1.8', color: '#e5e7eb', marginBottom: '16px' }}>
          <div style={{ marginBottom: '12px' }}><strong>Description:</strong> {upgrade.description}</div>
          <div style={{ marginBottom: '12px' }}><strong>Cost:</strong> £{upgrade.cost.toLocaleString()}</div>
          <div style={{ marginBottom: '12px' }}><strong>Annual Savings:</strong> £{upgrade.savings.toLocaleString()}</div>
          <div style={{ marginBottom: '12px' }}><strong>Payback Period:</strong> {upgrade.payback} years</div>
          <div style={{ marginBottom: '12px' }}><strong>EPC Impact:</strong> +{upgrade.epcImpact} points</div>
          <div style={{ marginBottom: '12px' }}><strong>Installation Time:</strong> {upgrade.installTime}</div>
          {upgrade.grant > 0 && <div style={{ marginBottom: '12px', color: '#10b981' }}><strong>Government Grant:</strong> £{upgrade.grant.toLocaleString()}</div>}
          <div style={{ marginBottom: '12px' }}><strong>Benefits:</strong></div>
          <ul style={{ marginLeft: '20px', marginBottom: '12px' }}>
            {upgrade.benefits.map((b, i) => <li key={i}>{b}</li>)}
          </ul>
          <div style={{ marginBottom: '12px' }}><strong>Considerations:</strong></div>
          <ul style={{ marginLeft: '20px' }}>
            {upgrade.considerations.map((c, i) => <li key={i}>{c}</li>)}
          </ul>
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button onClick={() => { onAdd(upgrade); onClose(); }} style={{ flex: 1, background: '#10b981', border: 'none', borderRadius: '6px', padding: '10px', color: 'white', cursor: 'pointer', fontWeight: 500 }}>Add to Plan</button>
          <button onClick={onClose} style={{ flex: 1, background: '#334155', border: 'none', borderRadius: '6px', padding: '10px', color: 'white', cursor: 'pointer' }}>Close</button>
        </div>
      </div>
    </div>
  );
};

const upgrades = [
  {
    id: 1,
    name: 'Loft Insulation',
    emoji: '🏠',
    cost: 600,
    savings: 200,
    payback: 3,
    epcImpact: 10,
    installTime: '1-2 days',
    grant: 0,
    description: 'Add insulation to your loft to reduce heat loss. Typical 200mm mineral wool.',
    benefits: ['Reduces heat loss by 25%', 'Quick installation', 'Immediate savings', 'Better summer cooling'],
    considerations: ['Access to loft needed', 'Ventilation must be maintained', 'May need professional installation'],
    priority: 1
  },
  {
    id: 2,
    name: 'Cavity Wall Insulation',
    emoji: '🧱',
    cost: 2000,
    savings: 280,
    payback: 7,
    epcImpact: 12,
    installTime: '1-3 days',
    grant: 0,
    description: 'Fill cavity walls with insulation material. For homes with cavity walls only.',
    benefits: ['Prevents cold bridging', 'No internal space loss', 'Improves acoustics', 'Works with all systems'],
    considerations: ['Only for cavity walls', 'Professional installation required', 'Limited to solid construction homes'],
    priority: 2
  },
  {
    id: 3,
    name: 'Solid Wall External Insulation',
    emoji: '🏗️',
    cost: 12000,
    savings: 450,
    payback: 27,
    epcImpact: 18,
    installTime: '3-4 weeks',
    grant: 0,
    description: 'External insulation for solid wall homes. Premium option with best performance.',
    benefits: ['Eliminates cold spots', 'Improves curb appeal', 'Reduces mold', 'Lasts 50+ years'],
    considerations: ['Requires scaffolding', 'Planning permission likely', 'Can affect windows/doors', 'Most expensive insulation'],
    priority: 3
  },
  {
    id: 4,
    name: 'Double Glazing',
    emoji: '🪟',
    cost: 7500,
    savings: 150,
    payback: 50,
    epcImpact: 8,
    installTime: '2-3 weeks',
    grant: 0,
    description: 'Replace single-pane windows with double-glazed units. Typical 10 windows.',
    benefits: ['Reduces drafts', 'Noise reduction', 'Better insulation', 'Modern appearance'],
    considerations: ['Long payback', 'Secondary glazing cheaper alternative', 'Installation disruption', 'May need frame replacement'],
    priority: 4
  },
  {
    id: 5,
    name: 'Draught Proofing',
    emoji: '💨',
    cost: 550,
    savings: 75,
    payback: 7,
    epcImpact: 4,
    installTime: '1 day',
    grant: 0,
    description: 'Seal gaps around doors and windows. Quick win with immediate results.',
    benefits: ['Cheapest option', 'DIY possible', 'Immediate comfort improvement', 'No installation required for DIY'],
    considerations: ['One-time fix', 'Seals may degrade', 'Limited impact alone', 'Best with other measures'],
    priority: 5
  },
  {
    id: 6,
    name: 'Solar PV 4kW',
    emoji: '☀️',
    cost: 7000,
    savings: 700,
    payback: 10,
    epcImpact: 15,
    installTime: '2-3 days',
    grant: 0,
    description: 'Install 4kW solar panel system. Typical for 3-bed homes. 0% VAT.',
    benefits: ['0% VAT on panels & battery', '£400-600/year savings', 'SEG export income', '25-year warranty'],
    considerations: ['South-facing roof best', 'Planning usually not needed', 'Grid connection fee £50-100', 'Requires good roof condition'],
    priority: 6
  },
  {
    id: 7,
    name: 'Solar PV 6kW',
    emoji: '☀️',
    cost: 9800,
    savings: 1000,
    payback: 10,
    epcImpact: 18,
    installTime: '2-3 days',
    grant: 0,
    description: 'Larger 6kW solar system for bigger homes or high usage.',
    benefits: ['Higher generation', 'Better for families', 'Battery-ready inverter', 'Future-proof'],
    considerations: ['Larger roof space needed', 'Higher upfront cost', 'May need 3-phase upgrade', 'Scaffolding likely needed'],
    priority: 7
  },
  {
    id: 8,
    name: 'Battery Storage 10kWh',
    emoji: '🔋',
    cost: 5000,
    savings: 350,
    payback: 13,
    epcImpact: 5,
    installTime: '1-2 days',
    grant: 0,
    description: 'Store solar energy for evening use. Requires solar PV first.',
    benefits: ['Use solar at night', '65% self-consumption possible', 'Backup power in outages', 'Quieter than generator'],
    considerations: ['Requires solar first', 'Space needed for installation', '10-15 year lifespan', 'Warranty critical'],
    priority: 8
  },
  {
    id: 9,
    name: 'Air Source Heat Pump',
    emoji: '❄️',
    cost: 10500,
    savings: 900,
    payback: 12,
    epcImpact: 20,
    installTime: '3-5 days',
    grant: 7500,
    description: 'Replace gas boiler with heat pump. £7,500 BUS grant available.',
    benefits: ['30-50% cheaper than gas', '£7,500 government grant', 'Works with solar', 'Quiet operation possible'],
    considerations: ['Radiators may need upsizing', 'Needs good insulation', '8mm microbore piping often needed', 'Net cost £3,000 after grant'],
    priority: 9
  },
  {
    id: 10,
    name: 'Ground Source Heat Pump',
    emoji: '🌍',
    cost: 20000,
    savings: 1200,
    payback: 17,
    epcImpact: 25,
    installTime: '2-3 weeks',
    grant: 7500,
    description: 'Most efficient heat pump option. Requires borehole drilling.',
    benefits: ['Highest efficiency (COP 4.2+)', 'Works in cold climates', 'Quietest operation', 'Premium long-term value'],
    considerations: ['Expensive upfront', 'Borehole drilling required', 'Ground survey needed', 'Net cost £12,500 after grant'],
    priority: 10
  },
  {
    id: 11,
    name: 'Smart Thermostat',
    emoji: '🌡️',
    cost: 500,
    savings: 150,
    payback: 3,
    epcImpact: 5,
    installTime: '2-4 hours',
    grant: 0,
    description: 'Zone control and weather compensation. Works with all heating systems.',
    benefits: ['10-15% energy savings', 'Remote control', 'Learning algorithm', 'Easy installation'],
    considerations: ['WiFi needed', 'Subscription optional', 'Works with most systems', 'Battery backup recommended'],
    priority: 11
  },
  {
    id: 12,
    name: 'Floor Insulation',
    emoji: '🏠',
    cost: 1400,
    savings: 120,
    payback: 12,
    epcImpact: 7,
    installTime: '2-4 days',
    grant: 0,
    description: 'Insulate ground floors. Reduces heat loss and improves comfort.',
    benefits: ['Warmer floors', 'Eliminates cold spots', 'Better comfort', 'Improves air quality'],
    considerations: ['Access to underfloor space needed', 'May need joist work', 'Survey recommended', 'Not always cost-effective'],
    priority: 12
  }
];

export default function UpgradeSequencer() {
  const [selectedModal, setSelectedModal] = useState(null);
  const [addedUpgrades, setAddedUpgrades] = useState([]);
  const [epcRating, setEpcRating] = useState('E');
  const [region, setRegion] = useState('SW');

  const regionMultiplier = { 'SW': 1.0, 'SE': 1.12, 'E': 1.05, 'N': 0.95, 'NW': 0.95, 'M': 1.0, 'W': 0.98, 'WM': 0.98, 'EE': 1.02, 'Y': 0.95, 'NE': 0.92, 'SC': 0.95, 'WA': 0.95, 'EW': 0.95, 'GL': 1.0 };

  const projections = useMemo(() => {
    const totalCost = addedUpgrades.reduce((sum, u) => sum + (u.cost * (regionMultiplier[region] || 1.0)), 0);
    const totalSavings = addedUpgrades.reduce((sum, u) => sum + u.savings, 0);
    const totalGrant = addedUpgrades.reduce((sum, u) => sum + u.grant, 0);
    const avgPayback = addedUpgrades.length > 0 ? Math.round(totalCost / Math.max(1, totalSavings)) : 0;
    const netCost = Math.max(0, totalCost - totalGrant);
    const savings10yr = totalSavings * 10;
    const epcGain = addedUpgrades.reduce((sum, u) => sum + u.epcImpact, 0);

    return { totalCost: Math.round(totalCost), totalSavings: Math.round(totalSavings), totalGrant, netCost: Math.round(netCost), avgPayback, savings10yr: Math.round(savings10yr), epcGain };
  }, [addedUpgrades, region]);

  const handleAddUpgrade = (upgrade) => {
    if (!addedUpgrades.find(u => u.id === upgrade.id)) {
      setAddedUpgrades([...addedUpgrades, { ...upgrade, cost: upgrade.cost * (regionMultiplier[region] || 1.0) }]);
    }
  };

  const handleRemoveUpgrade = (upgradeId) => {
    setAddedUpgrades(addedUpgrades.filter(u => u.id !== upgradeId));
  };

  return (
    <div>
      <div className="solar-card">
        <h3 style={{ margin: '0 0 1rem', fontSize: '18px' }}>
          Whole-Home Upgrade Sequencer
          <HelpIcon text="Plan your energy upgrades. Select improvements, see costs, grants & 10-year savings. Optimal sequence: insulation first, then heating, then solar." />
        </h3>

        <div className="solar-grid-2">
          <div className="solar-input-group">
            <label className="solar-label">EPC Rating <HelpIcon text="Current energy rating. A=best, G=worst." /></label>
            <select className="solar-input" value={epcRating} onChange={(e) => setEpcRating(e.target.value)}>
              <option value="A">A (Excellent)</option>
              <option value="B">B</option>
              <option value="C">C</option>
              <option value="D">D</option>
              <option value="E">E</option>
              <option value="F">F</option>
              <option value="G">G (Poor)</option>
            </select>
          </div>

          <div className="solar-input-group">
            <label className="solar-label">Region <HelpIcon text="Affects labor costs." /></label>
            <select className="solar-input" value={region} onChange={(e) => setRegion(e.target.value)}>
              <option value="SW">South West (baseline)</option>
              <option value="SE">South East (+12%)</option>
              <option value="E">East (+5%)</option>
              <option value="M">Midlands (baseline)</option>
              <option value="W">Wales (-2%)</option>
              <option value="WM">West Midlands (-2%)</option>
              <option value="NW">North West (-5%)</option>
              <option value="N">North (-5%)</option>
              <option value="NE">North East (-8%)</option>
              <option value="SC">Scotland (-5%)</option>
            </select>
          </div>
        </div>
      </div>

      <div className="solar-card">
        <h3 style={{ margin: '0 0 1rem', fontSize: '18px' }}>Available Upgrades</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '12px' }}>
          {upgrades.map(upgrade => (
            <div key={upgrade.id} onClick={() => setSelectedModal(upgrade)} style={{ background: '#334155', border: '1px solid #475569', borderRadius: '8px', padding: '12px', cursor: 'pointer', textAlign: 'center' }}>
              <div style={{ fontSize: '24px', marginBottom: '8px' }}>{upgrade.emoji}</div>
              <div style={{ fontSize: '12px', fontWeight: 500, color: '#e5e7eb', marginBottom: '4px' }}>{upgrade.name}</div>
              <div style={{ fontSize: '11px', color: '#94a3b8', marginBottom: '8px' }}>£{(upgrade.cost * (regionMultiplier[region] || 1.0)).toLocaleString()}</div>
              <button onClick={(e) => { e.stopPropagation(); setSelectedModal(upgrade); }} style={{ width: '100%', background: '#0066cc', border: 'none', borderRadius: '6px', padding: '6px', color: 'white', fontSize: '11px', cursor: 'pointer' }}>Details</button>
            </div>
          ))}
        </div>
      </div>

      <div className="solar-card">
        <h3 style={{ margin: '0 0 1rem', fontSize: '18px' }}>Your Plan ({addedUpgrades.length} upgrades)</h3>
        {addedUpgrades.length === 0 ? (
          <p style={{ color: '#94a3b8' }}>No upgrades selected yet. Click "Details" on any upgrade above.</p>
        ) : (
          <div>
            {addedUpgrades.map(upgrade => (
              <div key={upgrade.id} className="solar-row" style={{ marginBottom: '8px', padding: '8px', background: '#334155', borderRadius: '6px' }}>
                <span>{upgrade.emoji} {upgrade.name}</span>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                  <span className="solar-currency">£{Math.round(upgrade.cost).toLocaleString()}</span>
                  <button onClick={() => handleRemoveUpgrade(upgrade.id)} style={{ background: '#ef4444', border: 'none', borderRadius: '4px', padding: '4px 8px', color: 'white', cursor: 'pointer', fontSize: '11px' }}>Remove</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="solar-card">
        <h3 style={{ margin: '0 0 1rem', fontSize: '18px' }}>Plan Summary</h3>
        <div className="solar-grid-2">
          <div className="solar-metric">
            <div className="solar-metric-label">Total Cost</div>
            <div className="solar-currency" style={{ fontSize: '22px' }}>£{projections.totalCost.toLocaleString()}</div>
          </div>
          <div className="solar-metric">
            <div className="solar-metric-label">Government Grants</div>
            <div className="solar-currency" style={{ fontSize: '22px', color: '#10b981' }}>−£{projections.totalGrant.toLocaleString()}</div>
          </div>
        </div>
        <div className="solar-grid-2">
          <div className="solar-metric">
            <div className="solar-metric-label">Net Cost</div>
            <div className="solar-currency" style={{ fontSize: '22px' }}>£{projections.netCost.toLocaleString()}</div>
          </div>
          <div className="solar-metric">
            <div className="solar-metric-label">Annual Savings</div>
            <div className="solar-currency" style={{ fontSize: '22px', color: '#10b981' }}>£{projections.totalSavings.toLocaleString()}</div>
          </div>
        </div>
        <div className="solar-grid-2">
          <div className="solar-metric">
            <div className="solar-metric-label">Payback Period</div>
            <div className="solar-metric-value">{projections.avgPayback} years</div>
          </div>
          <div className="solar-metric">
            <div className="solar-metric-label">10-Year Savings</div>
            <div className="solar-currency" style={{ fontSize: '22px', color: '#10b981' }}>£{projections.savings10yr.toLocaleString()}</div>
          </div>
        </div>
        <div className="solar-metric" style={{ marginTop: '12px', background: '#064e3b' }}>
          <div className="solar-metric-label" style={{ color: '#a7f3d0' }}>EPC Rating Improvement</div>
          <div style={{ fontSize: '18px', fontWeight: 600, color: '#10b981' }}>+{projections.epcGain} points</div>
        </div>
      </div>

      {selectedModal && <UpgradeModal upgrade={selectedModal} onClose={() => setSelectedModal(null)} onAdd={handleAddUpgrade} />}
    </div>
  );
}